import { _ } from "../../polyglot/polyglot.js";
import { htmlCanvas, Widget } from "@foretagsplatsen/widgetjs";

/**
 * Render the number of given elements, with a tooltip showing all elements.
 *
 * @param {Renderable[]} spec.elements - Elements to count.
 * @param {string} spec.label - Label rendered next to the number of elements.
 * @param {string} [spec.pluralLabel] - Optional plural version of
 * `label`. When omitted, use `label`.
 */
export default class CountWidget extends Widget {
	constructor({ elements, label, pluralLabel }) {
		super(...arguments);
		this._elements = elements;
		this._label = label;
		this._pluralLabel = pluralLabel || this._label;
	}

	renderContentOn(html) {
		const length = this._elements.length;

		const span = html.span(
			{
				class: "count",
				title: "", // needed dummy title for the tooltip to be displayed
				"data-test": "count",
			},
			_("{count} {label}", "{count} {pluralLabel}", length, {
				count: length,
				label: this._label,
				pluralLabel: this._pluralLabel,
			}),
		);

		if (length > 0) {
			span.asJQuery().tooltip({
				html: true,
				content: () => {
					const canvas = htmlCanvas();

					this._elements.forEach((elt) => {
						canvas.render(elt);
						canvas.br();
					});

					return canvas.root.asJQuery().get();
				},
			});
		}
	}
}
